module.exports = "Key : {{ params.key }}<br>\nBackUrl : {{ params.back }}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/no-content/no-content.html
// module id = 76
// module chunks = 3